import QUERY from 'lodash'

export default {
  methods: {

    transformToImageUrl (path = '') {
      return `${process.env.VUE_APP_API_BASE_URL}/${path}`
    },

    sampleImage () {
      return this.transformToImageUrl(process.env.VUE_APP_SAMPLE_IMAGE)
    },

    getCompany (rootDirectory = 'branding') {
      return `${rootDirectory}/${process.env.VUE_APP_COMPANY_LOGO}`
    },

    getProfile (rootDirectory = 'branding') {
      return `${rootDirectory}/${process.env.VUE_APP_PROFILE_LOGO}`
    },

    getOfficerProfile (photoUrl) {
      return `${process.env.VUE_APP_API_BASE_URL}/${photoUrl}`
    },

    getCustomerProfile (photos = []) {
      const customerPhoto = QUERY.first(photos)
      if (customerPhoto) {
        return `${process.env.VUE_APP_API_BASE_URL}/customer-photos-attachments/${customerPhoto.attachment_path}/${customerPhoto.file_name}`
      }

      return `${window.location.origin}/img/invalid-image.png`
    },

    getTradingTermAttachmentPath (tradingTerm) {
      if (tradingTerm) {
        return `${process.env.VUE_APP_API_BASE_URL}/trading-terms-attachments/${tradingTerm.attachment_path}/${tradingTerm.file_name}`
      }

      return `${window.location.origin}/img/invalid-image.png`
    }

  }
}
